import React, { Component } from "react";
import { Control } from "react-redux-form";

export class ControlSelect extends Component {
    onChangeAction = (model, value) => {
        const { onChangeAction } = this.props;
        if (onChangeAction !== undefined && onChangeAction !== null) {
            onChangeAction(model, value);
        }
    };

    render() {
        const { model, label, value, options, isRequired, placeholder, onChangeAction, className } = this.props;
        let validators = {};

        if (isRequired) {
            Object.assign(validators, {
                required: (val) => val && val.length
            });
        }

        const selectedOptions = options.length > 0 ? options.filter(r => r.FilterName == value || r.FilterValue == value) : [];
        const selectedValue = selectedOptions.length > 0 ? selectedOptions[0].FilterValue : "";

        return (
            <div className="custom-select-container">
                <div className="custom-select-label text-uppercase">{label} {isRequired && <span className="color-red">*</span>}</div>
                <Control.select
                    model={model}
                    id="floatingSelect"
                    className={className}
                    validators={validators}
                    changeAction={onChangeAction !== undefined ? this.onChangeAction : undefined}
                    validateOn="change"
                    value={selectedValue}
                    updateOn="change">
                    <option key={-1} value="" disabled hidden>{placeholder ?? ""}</option>
                    {
                        options.map(item => {
                            return (<option key={item.FilterId} value={item.FilterValue}>{item.FilterName}</option>)
                        })
                    }
                </Control.select>
            </div>
        );
    }
}

export class ControlText extends Component {
    constructor(props){
        super(props);
        this.state = {
            value: props.value || ''
        }
    }

    handleChange = (e) =>{
        this.setState({value: e.target.value});
    }

    componentDidUpdate(prevProps) {
       
        if (this.props.value !== prevProps.value) {
            this.setState({ value: this.props.value || '' });
        }
    }

    render() {
        const { model, label, disabled, isRequired, maxLength, placeholder, customClass } = this.props;
        let validators = {};

        if (isRequired) {
            Object.assign(validators, {
                required: (val) => val && val.length
            });
        }
        if (maxLength) {
            Object.assign(validators, {
                length: (val) => !val || (val && val.length <= maxLength)
            });
        }
        return (
            <div className={`custom-input-wrapper ${customClass}`}>
                <div className="custom-input-container">
                    <div className="custom-input-label text-uppercase">{label} {isRequired && <span className="color-red">*</span>}</div>
                    <Control
                        type="text"
                        model={model}
                        value={this.state.value}
                        placeholder={placeholder ?? ""}
                        maxLength={maxLength}
                        className="input-filter"
                        updateOn="change"
                        validators={validators}
                        validateOn="change"
                        disabled={disabled}
                        onChange={this.handleChange}
                    />
                </div>
            </div>
        );
    }
}

export class ControlTextarea extends Component {
    constructor(props){
        super(props);
        this.state = {
            value: props.value || "",
        }

    }
    handleChange = (e) => {
        this.setState({ value: e.target.value });
    }

    componentDidUpdate(prevProps) {
       
        if (this.props.value !== prevProps.value) {
            this.setState({ value: this.props.value || '' });
        }
    }
    render() {
        const { model, label, rows, isRequired, maxLength, colClassName, placeholder } = this.props;
        let validators = {};

        if (isRequired) {
            Object.assign(validators, {
                required: (val) => val && val.length
            });
        }
        if (maxLength) {
            Object.assign(validators, {
                length: (val) => !val || (val && val.length <= maxLength)
            });
        }

        return (
            <div className={`custom-input-container ${colClassName ?? ""}`}>
                <div className="custom-input-label text-uppercase">{label} {isRequired && <span className="color-red">*</span>}</div>
                <Control type="textarea"
                    model={model}
                    placeholder={placeholder ?? ""}
                    maxLength={maxLength}
                    rows={rows ?? 1}
                    className="input-filter"
                    validators={validators}
                    validateOn="change"
                    value={this.state.value}
                    onChange={this.handleChange}
                    updateOn="change" />
            </div>
        );
    }
}